import { getSolarRecommand } from '@/service/solar-calculator';
import { useGlobal } from '@/utils/useGlobal';
import Fan from '@elem/SVGIcon/OutdoorRecreation/Fan';
import ElectricBlanket from '@elem/SVGIcon/PowerBackup/ElectricBlanket';
import MiniFridge from '@elem/SVGIcon/PowerBackup/MiniFridge';
import Refrigerator from '@elem/SVGIcon/PowerBackup/Refrigerator';
import CarFridge from '@elem/SVGIcon/VanlifeRoadtrips/CarFridge';
import { PictureType } from '@elem/compCommon/EFPicture';
import { saveAICookieForShopify } from '@elem/ui-common/utils/CookieForShopify';
import Camera from 'elem/SVGIcon/OutdoorRecreation/Camera';
import Projector from 'elem/SVGIcon/OutdoorRecreation/Projector';
import CompactAndPortable from 'elem/SVGIcon/PowerBackup/CompactAndPortable';
import Display from 'elem/SVGIcon/PowerBackup/Display';
import EnergyConserved from 'elem/SVGIcon/PowerBackup/EnergyConserved';
import Laptop from 'elem/SVGIcon/PowerBackup/Laptop';
import Light from 'elem/SVGIcon/PowerBackup/Light';
import MultiOutlets from 'elem/SVGIcon/PowerBackup/MultiOutlets';
import PC from 'elem/SVGIcon/PowerBackup/PC';
import Phone from 'elem/SVGIcon/PowerBackup/Phone';
import PlugAndPlay from 'elem/SVGIcon/PowerBackup/PlugAndPlay';
import WiFiRouter from 'elem/SVGIcon/PowerBackup/WiFiRouter';
import WaterPump from 'elem/SVGIcon/VanlifeRoadtrips/WaterPump';
import EFPicture from 'elem/compCommon/EFPicture';
import { Scrollbar } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import css from './index.module.scss';

export default function E({ callBuy }: any) {
    const { useLang, useState, useEffect, useRouter, Link, gtm } = useGlobal();
    const { t } = useLang('powerbackup');
    const { locale } = useRouter();
    const [open, setOpen] = useState(false);

    const icons: any = [
        {
            icon: <PlugAndPlay className="icon" />,
            text: t('secE_icon1'),
        },
        {
            icon: <CompactAndPortable className="icon" />,
            text: t('secE_icon2'),
        },
        {
            icon: <MultiOutlets className="icon" />,
            text: t('secE_icon3'),
        },
        {
            icon: <EnergyConserved className="icon" />,
            text: t('secE_icon4'),
        },
    ];

    const IMG_MAP: any = {
        us: ['river2.png', 'river2max.png'],
        au: ['river2_au.png', 'river2max_au.png'],
        kr: ['river2_eu.png', 'river2max_eu.png'],
    };

    const cards: any = [
        {
            img: '',
            power: t('secE_card1_power'),
            title: t('secE_card1_title'),
            link_more: (() => {
                const localMap: any = {
                    us: 'https://us.ecoflow.com/products/river-3-plus-portable-power-station?41636514136137',
                    ca: 'https://ca.ecoflow.com/products/river-3-plus-portable-power-station?variant=52355185279347',
                    au: 'https://au.ecoflow.com/products/river-2-portable-power-station',
                    kr: 'https://kr.ecoflow.com/products/river-3-ups-portable-power-station',
                };
                return localMap[locale] || localMap.us;
            })(),
            productId: (() => {
                const localMap: any = {
                    us: '7290968473673',
                    ca: '15039583682931',
                    au: '7756518654150',
                    kr: '8499061194921',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '41636514136137',
                    ca: '52355185279347',
                    au: '42649688244422',
                    kr: '46312076738729',
                };
                return localMap[locale] || localMap.us;
            })(),
            descArr: [t('secE_card1_desc1'), t('secE_card1_desc2'), t('secE_card1_desc3')],
            iconArr: [
                {
                    icon: <Light className="card-icon" />,
                    title: t.rich('secE_card1_icon1_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secE_card1_icon1_desc'),
                },
                {
                    icon: <Phone className="card-icon" />,
                    title: t.rich('secE_card1_icon2_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secE_card1_icon2_desc'),
                },
                {
                    icon: ['au'].includes(locale) ? (
                        <Camera className="card-icon" />
                    ) : ['kr'].includes(locale) ? (
                        <Display className="card-icon" />
                    ) : (
                        <WiFiRouter className="card-icon" />
                    ),
                    title: t.rich('secE_card1_icon3_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secE_card1_icon3_desc'),
                },
                {
                    icon: ['au', 'kr'].includes(locale) ? <Fan className="card-icon" width="33px" height="33px" /> : <Laptop className="card-icon" />,
                    title: t.rich('secE_card1_icon4_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secE_card1_icon4_desc'),
                },
                {
                    icon: ['au', 'kr'].includes(locale) ? <CarFridge className="card-icon" /> : <Display className="card-icon" />,
                    title: t.rich('secE_card1_icon5_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secE_card1_icon5_desc'),
                },
                {
                    icon: ['au', 'kr'].includes(locale) ? (
                        <Projector className="card-icon" />
                    ) : ['us', 'ca'].includes(locale) ? (
                        <MiniFridge className="card-icon" />
                    ) : (
                        <Refrigerator className="card-icon" />
                    ),
                    title: t.rich('secE_card1_icon6_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secE_card1_icon6_desc'),
                },
            ],
        },
        {
            img: '',
            power: t('secE_card2_power'),
            title: t('secE_card2_title'),
            link_more: (() => {
                const localMap: any = {
                    us: 'https://us.ecoflow.com/products/river-3-plus-portable-power-station?variant=41636515807305',
                    ca: 'https://ca.ecoflow.com/products/river-2-max-portable-power-station?variant=43890788663450',
                    au: 'https://au.ecoflow.com/products/river-2-max-portable-power-station',
                    kr: 'https://kr.ecoflow.com/products/ecoflow-river-3-plus-portable-power-station',
                };
                return localMap[locale] || localMap.us;
            })(),
            productId: (() => {
                const localMap: any = {
                    us: '7290968473673',
                    ca: '7539941933210',
                    au: '7756526026950',
                    kr: '8499164414121',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '41636515807305',
                    ca: '43890788663450',
                    au: '42649690210502',
                    kr: '45733372068009',
                };
                return localMap[locale] || localMap.us;
            })(),
            descArr: [t('secE_card2_desc1'), t('secE_card2_desc2'), t('secE_card2_desc3')],
            iconArr: [
                {
                    icon: <Light className="card-icon" />,
                    title: t.rich('secE_card2_icon1_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secE_card2_icon1_desc'),
                },
                {
                    icon: <Phone className="card-icon" />,
                    title: t.rich('secE_card2_icon2_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secE_card2_icon2_desc'),
                },
                {
                    icon: ['au'].includes(locale) ? (
                        <WaterPump className="card-icon" />
                    ) : ['kr'].includes(locale) ? (
                        <Display className="card-icon" />
                    ) : (
                        <WiFiRouter className="card-icon" />
                    ),
                    title: t.rich('secE_card2_icon3_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secE_card2_icon3_desc'),
                },
                {
                    icon: ['au', 'kr'].includes(locale) ? <Fan className="card-icon" width="33px" height="33px" /> : <Laptop className="card-icon" />,
                    title: t.rich('secE_card2_icon4_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secE_card2_icon4_desc'),
                },
                {
                    icon: ['au', 'kr'].includes(locale) ? <CarFridge className="card-icon" /> : <Display className="card-icon" />,
                    title: t.rich('secE_card2_icon5_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secE_card2_icon5_desc'),
                },
                {
                    icon: ['au', 'kr'].includes(locale) ? (
                        <Projector className="card-icon" />
                    ) : ['us'].includes(locale) ? (
                        <MiniFridge className="card-icon" />
                    ) : (
                        <PC className="card-icon" />
                    ),
                    title: t.rich('secE_card2_icon6_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secE_card2_icon6_desc'),
                },
            ],
        },
    ];

    if (['us', 'ca'].includes(locale)) {
        cards.push({
            img: '',
            power: t('secE_card3_power'),
            title: t('secE_card3_title'),
            link_more: (() => {
                const localMap: any = {
                    us: 'https://us.ecoflow.com/products/river-2-pro-portable-power-station?variant=54320636198985',
                    ca: 'https://ca.ecoflow.com/products/river-2-pro-portable-power-station?variant=43725934461082',
                };
                return localMap[locale] || localMap.us;
            })(),
            productId: (() => {
                const localMap: any = {
                    us: '6859087282249',
                    ca: '7539942064282',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '54320636198985',
                    ca: '43725934461082',
                };
                return localMap[locale] || localMap.us;
            })(),
            descArr: [t('secE_card3_desc1'), t('secE_card3_desc2'), t('secE_card3_desc3')],
            iconArr: [
                {
                    icon: <Light className="card-icon" />,
                    title: t.rich('secE_card3_icon1_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secE_card3_icon1_desc'),
                },
                {
                    icon: <Phone className="card-icon" />,
                    title: t.rich('secE_card3_icon2_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secE_card3_icon2_desc'),
                },
                {
                    icon: <WiFiRouter className="card-icon" />,
                    title: t.rich('secE_card3_icon3_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secE_card3_icon3_desc'),
                },
                {
                    icon: <Laptop className="card-icon" width="33px" height="33px" />,
                    title: t.rich('secE_card3_icon4_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secE_card3_icon4_desc'),
                },
                {
                    icon: <Refrigerator className="card-icon" />,
                    title: t.rich('secE_card3_icon5_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secE_card3_icon5_desc'),
                },
                {
                    icon: <ElectricBlanket className="card-icon" />,
                    title: t.rich('secE_card3_icon6_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secE_card3_icon6_desc'),
                },
            ],
        });
    }

    if (['au'].includes(locale)) {
        cards.push({
            tag: t('common_card_tag_best_seller'),
            // img: '/responsive/picture/common-products/riverpro_za.png',
            power: t('secE_card3_power'),
            title: t('secE_card3_title'),
            link_more: (() => {
                const localMap: any = {
                    au: 'https://au.ecoflow.com/products/river-2-pro-portable-power-station',
                };
                return localMap[locale] || localMap.us;
            })(),
            productId: (() => {
                const localMap: any = {
                    au: '7756526584006',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    au: '42673598824646',
                };
                return localMap[locale] || localMap.us;
            })(),
            descArr: [t('secE_card3_desc1'), t('secE_card3_desc2'), t('secE_card3_desc3')],
            iconArr: [
                {
                    icon: <Light className="card-icon" />,
                    title: t.rich('secE_card3_icon1_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secE_card3_icon1_desc'),
                },
                {
                    icon: <Phone className="card-icon" />,
                    title: t.rich('secE_card3_icon2_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secE_card3_icon2_desc'),
                },
                {
                    icon: <WaterPump className="card-icon" />,
                    title: t.rich('secE_card3_icon3_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secE_card3_icon3_desc'),
                },
                {
                    icon: <Fan className="card-icon" width="33px" height="33px" />,
                    title: t.rich('secE_card3_icon4_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secE_card3_icon4_desc'),
                },
                {
                    icon: <CarFridge className="card-icon" />,
                    title: t.rich('secE_card3_icon5_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secE_card3_icon5_desc'),
                },
                {
                    icon: <Projector className="card-icon" />,
                    title: t.rich('secE_card3_icon6_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secE_card3_icon6_desc'),
                },
            ],
        });
    }

    const [cardLists, setCardLists] = useState(cards);

    const handleBuy = (card: any) => {
        try {
            // @ts-ignore
            window?.fbq && window?.fbq('track', 'Search');
        } catch (e) {
            console.error(e);
        } finally {
            callBuy({
                discountPrice: card?.discountPrice,
                originalPrice: card?.originalPrice,
                inventory: card?.inventory,
                productId: card?.productId,
                variantId: card?.variantId,
                img: card?.img,
                title: card?.title,
            });
            saveAICookieForShopify(card?.link_buy, locale, true);
        }
    };

    let originX = 0,
        startX = 0;
    const onTouchStart = (e: any) => {
        originX = parseFloat(e.currentTarget?.style.left) || 0;
        startX = e.targetTouches[0]?.clientX;
    };

    const onTouchMove = (e: any) => {
        const moveX = e.targetTouches[0]?.clientX;
        const endX = originX + moveX - startX;
        if (endX <= 0 && endX >= window.innerWidth - e.currentTarget.offsetWidth) {
            e.currentTarget.style.left = `${endX}px`;
        }
    };

    const IMG_MAP_kv: any = {
        us: '',
        kr: '_kr',
    };

    const imgProps: PictureType = {
        className: 'back-img',
        src: `/responsive/picture/power-backup/5${IMG_MAP_kv[locale] || IMG_MAP_kv.us}.jpg`,
        srcPad: `/responsive/picture/power-backup/5_pad${IMG_MAP_kv[locale] || IMG_MAP_kv.us}.jpg`,
        alt: t('secE_title'),
    } as PictureType;

    const handleLinkClick = (card?: any) => {
        saveAICookieForShopify(card?.link_more, locale);

        gtm.push({
            event: 'uaEvent',
            event_name: 'buy',
            product_name: card.title,
            position: 'In-Products Module',
        });

        gtm.push({
            event: 'uaEvent',
            event_name: 'select_product',
            list_name: t('secE_title'),
            product_name: card.title,
            button_name: t('common_card_more'),
        });
    };
    useEffect(() => {
        const tempArr = [...cards];
        const getAsynItem = async (productId: string, variantId: string, k: number) => {
            return await new Promise(async (resolve, reject) => {
                try {
                    const res = await getSolarRecommand({ productId, variantId }, locale);
                    if (res?.code === '0') {
                        tempArr[k].discountPrice = res?.data?.price;
                        tempArr[k].originalPrice = res?.data?.compareAtPrice || res?.data?.price;
                        tempArr[k].inventory = res?.data?.inventoryQuantity ?? undefined;
                        // tempArr[k].inventory = 1;
                        tempArr[k].link_buy = `https://${locale}.ecoflow.com/cart/${tempArr[k].variantId}:1?channel=buy_button`;
                        if (!tempArr[k].img) {
                            tempArr[k].img = res?.data?.variantImg;
                        }
                        return resolve(res);
                    } else {
                        console.error(res?.message);
                        return reject(res?.message);
                    }
                } catch (e) {
                    console.error(e);
                    return reject(e);
                }
            });
        };
        const promises = tempArr?.map((item: any, k: number) => getAsynItem(item?.productId, item.variantId, k));
        Promise.all(promises)
            .then(() => {
                setCardLists(tempArr?.filter((list: any) => list?.inventory !== undefined));
            })
            .catch((e) => {
                console.error(e);
            });
    }, []);

    return (
        <div id="power-backup-E" className={`power-backup-E ef-layer ${css['power-backup-E']}`}>
            <div className="text-box">
                <p className="subtitle">{t('secE_subtitle')}</p>
                <p className="title">{t('secE_title')}</p>
                <p className="desc">{t('secE_desc')}</p>
                <div className="icon-wrapper">
                    <ul className="icons" onTouchStart={onTouchStart} onTouchMove={onTouchMove}>
                        {icons?.map((icon: any, k: number) => (
                            <li className="icon-item" key={k}>
                                {icon?.icon}
                                <p className="icon-text">{icon?.text}</p>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
            <EFPicture {...imgProps} />
            <ul className="cards common-cards">
                {cardLists?.map((card: any, k: number) => (
                    <li className="card-item" key={k}>
                        {card?.tag && <span className="card-tag">{card?.tag}</span>}
                        <EFPicture src={card?.img} alt={card?.title} />
                        <p className="card-power">{card?.power}</p>
                        <p className="card-title">{card?.title}</p>
                        <ul className="card-descs">
                            {card?.descArr?.map((desc: any, m: number) => (
                                <li className="card-desc" key={`${k}_${m}`}>
                                    {desc}
                                </li>
                            ))}
                        </ul>
                        <ul className={`card-icons${open ? ' open' : ''}`}>
                            {card?.iconArr?.map((icon: any, n: number) => (
                                <li className="card-icon-item" key={`${k}_${n}`}>
                                    {icon?.icon}
                                    <p className="icon-title">{icon?.title}</p>
                                    <p className="icon-desc">{icon?.desc}</p>
                                </li>
                            ))}
                        </ul>
                        {!open && (
                            <span className="card-arrow" onClick={() => setOpen(true)}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="5" viewBox="0 0 9 5" fill="none">
                                    <path d="M1.5 1L4.5 4L7.5 1" stroke="#AEAEAE" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </span>
                        )}
                        <div className="card-btns">
                            {card?.link_buy && locale === 'kr' ? <div className='card-btn-cart'>
                                <button className={`kr-shop${Number(card?.inventory) <= 0 ? ' disabled' : ''}`} onClick={() => window.open(card?.link_buy, '_blank')}>
                                    {t('common_card_buy_new')}
                                </button>
                                <button className={`kr-add-cart${Number(card?.inventory) <= 0 ? ' disabled' : ''}`} onClick={() => handleBuy(card)}>
                                    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M16.1665 20C16.1665 21.3807 17.2858 22.5 18.6665 22.5C20.0472 22.5 21.1664 21.3807 21.1664 20C21.1664 18.6193 20.0472 17.5 18.6665 17.5C17.2858 17.5 16.1665 18.6193 16.1665 20ZM19.7056 20.017C19.7056 20.5692 19.2579 21.017 18.7057 21.017C18.1534 21.017 17.7057 20.5692 17.7057 20.017C17.7057 19.4647 18.1534 19.017 18.7057 19.017C19.2579 19.017 19.7056 19.4647 19.7056 20.017Z" fill="currentColor"></path>
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M6.1665 20C6.1665 21.3807 7.28578 22.5 8.66647 22.5C10.0472 22.5 11.1664 21.3807 11.1664 20C11.1664 18.6193 10.0472 17.5 8.66647 17.5C7.28578 17.5 6.1665 18.6193 6.1665 20ZM9.70565 20.017C9.70565 20.5692 9.25794 21.017 8.70566 21.017C8.15339 21.017 7.70568 20.5692 7.70568 20.017C7.70568 19.4647 8.15339 19.017 8.70566 19.017C9.25794 19.017 9.70565 19.4647 9.70565 20.017Z" fill="currentColor"></path>
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M21.1664 6.66667H7.44731L7.18443 4.67432C7.02155 3.432 5.96318 2.5019 4.70956 2.5H2.83332C2.37309 2.5 2 2.8731 2 3.33333C2 3.79357 2.37309 4.16667 2.83332 4.16667H4.70829C5.12491 4.1673 5.4777 4.47733 5.53202 4.89167L6.79876 14.4923C6.96283 15.7441 8.0355 16.6774 9.29863 16.6666L18.0998 16.6667C19.2946 16.6897 20.3479 15.8418 20.5838 14.654L21.9835 7.66362C22.0868 7.1479 21.6923 6.66667 21.1664 6.66667ZM8.45117 14.275L7.66721 8.33333H20.1497L18.9493 14.328C18.8704 14.7252 18.5193 15.0079 18.1157 15.0002L9.29156 15C8.86345 15.0036 8.5059 14.6925 8.45117 14.275Z" fill="currentColor"></path>
                                        <path d="M14.5 9.5C14.5 9.22386 14.2761 9 14 9C13.7239 9 13.5 9.22386 13.5 9.5V11H12C11.7239 11 11.5 11.2239 11.5 11.5C11.5 11.7761 11.7239 12 12 12H13.5V13.5C13.5 13.7761 13.7239 14 14 14C14.2761 14 14.5 13.7761 14.5 13.5V12H16C16.2761 12 16.5 11.7761 16.5 11.5C16.5 11.2239 16.2761 11 16 11H14.5V9.5Z" fill="currentColor" stroke="currentColor" stroke-width="0.3"></path>
                                    </svg>
                                </button>
                            </div> :
                                card?.link_buy && (
                                    <>
                                        {Number(card?.inventory) <= 0 ? (
                                            <button disabled className={`btn-buy card-btn disable`}>
                                                {t('common_card_out')}
                                            </button>
                                        ) : (
                                            <p className={`btn-buy card-btn`} onClick={() => handleBuy(card)}>
                                                {t('common_card_buy')}
                                            </p>
                                        )}
                                    </>
                                )}
                            {card?.link_more && (
                                <Link
                                    className="btn-more card-btn"
                                    href={`${card?.link_more}${String(card?.link_more)?.indexOf('?') !== -1 ? '&' : '?'
                                        }utm_source=scenario+page&utm_medium=Pillar`}
                                    target="_blank"
                                    // dataLayer={{
                                    //     event: 'uaEvent',
                                    //     event_name: 'select_product',
                                    //     list_name: t('secE_title'),
                                    //     product_name: card.title,
                                    //     button_name: t('common_card_more'),
                                    // }}
                                    onClick={() => handleLinkClick(card)}
                                >
                                    {t('common_card_more')}
                                </Link>
                            )}
                        </div>
                    </li>
                ))}
            </ul>

            <Swiper
                className="cards swiper-box"
                effect="fade"
                modules={[Scrollbar]}
                spaceBetween={16}
                slidesPerView={'auto'}
                initialSlide={0}
                scrollbar={{
                    hide: false,
                    draggable: true,
                    dragSize: 32,
                    snapOnRelease: true,
                }}
            >
                {cardLists?.map((card: any, k: number) => (
                    <SwiperSlide className={`swiper-item card-item item-${k + 1}`} key={k}>
                        <EFPicture src={card?.img} alt={card?.title} />
                        <p className="card-power">{card?.power}</p>
                        <p className="card-title">{card?.title}</p>
                        <ul className="card-descs">
                            {card?.descArr?.map((desc: any, m: number) => (
                                <li className="card-desc" key={`${k}_${m}`}>
                                    {desc}
                                </li>
                            ))}
                        </ul>
                        <ul className={`card-icons${open ? ' open' : ''}`}>
                            {card?.iconArr?.map((icon: any, n: number) => (
                                <li className="card-icon-item" key={`${k}_${n}`}>
                                    {icon?.icon}
                                    <p className="icon-title">{icon?.title}</p>
                                    <p className="icon-desc">{icon?.desc}</p>
                                </li>
                            ))}
                        </ul>
                        {!open && (
                            <span className="card-arrow" onClick={() => setOpen(true)}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="5" viewBox="0 0 9 5" fill="none">
                                    <path d="M1.5 1L4.5 4L7.5 1" stroke="#AEAEAE" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </span>
                        )}
                        <div className="card-btns">
                            {card?.link_buy && locale === 'kr' ? <div className='card-btn-cart'>
                                <button className={`kr-shop${Number(card?.inventory) <= 0 ? ' disabled' : ''}`} onClick={() => window.open(card?.link_buy, '_blank')}>
                                    {t('common_card_buy_new')}
                                </button>
                                <button className={`kr-add-cart${Number(card?.inventory) <= 0 ? ' disabled' : ''}`} onClick={() => handleBuy(card)}>
                                    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M16.1665 20C16.1665 21.3807 17.2858 22.5 18.6665 22.5C20.0472 22.5 21.1664 21.3807 21.1664 20C21.1664 18.6193 20.0472 17.5 18.6665 17.5C17.2858 17.5 16.1665 18.6193 16.1665 20ZM19.7056 20.017C19.7056 20.5692 19.2579 21.017 18.7057 21.017C18.1534 21.017 17.7057 20.5692 17.7057 20.017C17.7057 19.4647 18.1534 19.017 18.7057 19.017C19.2579 19.017 19.7056 19.4647 19.7056 20.017Z" fill="currentColor"></path>
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M6.1665 20C6.1665 21.3807 7.28578 22.5 8.66647 22.5C10.0472 22.5 11.1664 21.3807 11.1664 20C11.1664 18.6193 10.0472 17.5 8.66647 17.5C7.28578 17.5 6.1665 18.6193 6.1665 20ZM9.70565 20.017C9.70565 20.5692 9.25794 21.017 8.70566 21.017C8.15339 21.017 7.70568 20.5692 7.70568 20.017C7.70568 19.4647 8.15339 19.017 8.70566 19.017C9.25794 19.017 9.70565 19.4647 9.70565 20.017Z" fill="currentColor"></path>
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M21.1664 6.66667H7.44731L7.18443 4.67432C7.02155 3.432 5.96318 2.5019 4.70956 2.5H2.83332C2.37309 2.5 2 2.8731 2 3.33333C2 3.79357 2.37309 4.16667 2.83332 4.16667H4.70829C5.12491 4.1673 5.4777 4.47733 5.53202 4.89167L6.79876 14.4923C6.96283 15.7441 8.0355 16.6774 9.29863 16.6666L18.0998 16.6667C19.2946 16.6897 20.3479 15.8418 20.5838 14.654L21.9835 7.66362C22.0868 7.1479 21.6923 6.66667 21.1664 6.66667ZM8.45117 14.275L7.66721 8.33333H20.1497L18.9493 14.328C18.8704 14.7252 18.5193 15.0079 18.1157 15.0002L9.29156 15C8.86345 15.0036 8.5059 14.6925 8.45117 14.275Z" fill="currentColor"></path>
                                        <path d="M14.5 9.5C14.5 9.22386 14.2761 9 14 9C13.7239 9 13.5 9.22386 13.5 9.5V11H12C11.7239 11 11.5 11.2239 11.5 11.5C11.5 11.7761 11.7239 12 12 12H13.5V13.5C13.5 13.7761 13.7239 14 14 14C14.2761 14 14.5 13.7761 14.5 13.5V12H16C16.2761 12 16.5 11.7761 16.5 11.5C16.5 11.2239 16.2761 11 16 11H14.5V9.5Z" fill="currentColor" stroke="currentColor" stroke-width="0.3"></path>
                                    </svg>
                                </button>
                            </div> :
                                card?.link_buy && (
                                    <>
                                        {Number(card?.inventory) <= 0 ? (
                                            <button disabled className={`btn-buy card-btn disable`}>
                                                {t('common_card_out')}
                                            </button>
                                        ) : (
                                            <p className={`btn-buy card-btn`} onClick={() => handleBuy(card)}>
                                                {t('common_card_buy')}
                                            </p>
                                        )}
                                    </>
                                )}
                            {card?.link_more && (
                                <Link
                                    className="btn-more card-btn"
                                    href={`${card?.link_more}${String(card?.link_more)?.indexOf('?') !== -1 ? '&' : '?'
                                        }utm_source=scenario+page&utm_medium=Pillar`}
                                    target="_blank"
                                    // dataLayer={{
                                    //     event: 'uaEvent',
                                    //     event_name: 'select_product',
                                    //     list_name: t('secE_title'),
                                    //     product_name: card.title,
                                    //     button_name: t('common_card_more'),
                                    // }}
                                    onClick={() => handleLinkClick(card)}
                                >
                                    {t('common_card_more')}
                                </Link>
                            )}
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
}
